import { useParams } from "react-router";
import { DocumentBlobCard } from "@/services/backend/filestorage/components/document-blob-card";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";

export function ContractFilesRoute() {
  const { contractId } = useParams();

  return (
    <DocumentBlobCard
      subdomain="omni"
      documentKind={GSMDocumentKind.Contract}
      documentId={contractId!}
      accept="application/pdf,image/jpeg,image/png"
    />
  );
}
